import UserActions from "../Types"
import Storage from "../../utils/storage";

const initialState = {
    isLoading: false,
    currentUser: null,
    currentUserData: null,
    data: {},
    error: null,
    isAuthenticated: false,
    isAuthenticating: false,
    authenticateUserSuccess: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UserActions.SET_CURRENT_USER:
            return {
                ...state,
                isLoading: false,
                currentUser: Storage.get("user-access-token"),
                data: Storage.get('decoded-data'),
                error: null,
                isAuthenticated: false
            }
        case UserActions.USER_LOGIN_START:
            return {
                ...state,
                isLoading: true,
                currentUser: null,
                isAuthenticated: false,
                error: null
            }
        case UserActions.USER_LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                currentUser: action.payload,
                isAuthenticated: true,
                error: null,
            }
        case UserActions.USER_LOGIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                currentUser: null,
                isAuthenticated: false,
                error: action.payload
            }
        case UserActions.AUTHENTICATE_USER_START:
            return {
                ...state,
                isAuthenticating: true,
                currentUser: null,
                isAuthenticated: false,
                authenticateUserSuccess: false,
                error: null
            }
        case UserActions.AUTHENTICATE_USER_SUCCESS:
            return {
                ...state,
                isAuthenticating: false,
                currentUser: action.payload,
                isAuthenticated: true,
                authenticateUserSuccess: true,
                error: null,
            }
        case UserActions.AUTHENTICATE_USER_FAILURE:
            return {
                ...state,
                isAuthenticating: false,
                currentUser: null,
                isAuthenticated: false,
                authenticateUserSuccess: false,
                error: action.payload
            }
        case UserActions.USER_LOG_OUT_START:
            return {
                ...state,
                isLoggingOut: true,
            }
        case UserActions.USER_LOG_OUT_SUCCESS:
            return {
                ...state,
                isLoggingOut: false,
                data: {},
                currentUser: null,
                error: null,
            }
        case UserActions.USER_LOG_OUT_FAILURE:
            return {
                ...state,
                isLoggingOut: false,
            }
        case UserActions.CLEAR_AUTHENTICATE_STATE:
            return {

            }
        default:
            return state;
    }
}